'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$CombinedRequestBuilder$() {
}
export { $c_Lpresto_Fetcher$CombinedRequestBuilder$ as $c_Lpresto_Fetcher$CombinedRequestBuilder$ };
$p = $c_Lpresto_Fetcher$CombinedRequestBuilder$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$CombinedRequestBuilder$;
/** @constructor */
function $h_Lpresto_Fetcher$CombinedRequestBuilder$() {
}
export { $h_Lpresto_Fetcher$CombinedRequestBuilder$ as $h_Lpresto_Fetcher$CombinedRequestBuilder$ };
$h_Lpresto_Fetcher$CombinedRequestBuilder$.prototype = $p;
$p.l = (function() {
  return "CombinedRequestBuilder";
});
$p.Gz = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((message) => {
    console.info(message);
  }));
});
var $d_Lpresto_Fetcher$CombinedRequestBuilder$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$CombinedRequestBuilder$, "presto.Fetcher$CombinedRequestBuilder$", ({
  IE: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_Fetcher$CombinedRequestBuilder$ as $d_Lpresto_Fetcher$CombinedRequestBuilder$ };
var $n_Lpresto_Fetcher$CombinedRequestBuilder$;
function $m_Lpresto_Fetcher$CombinedRequestBuilder$() {
  if ((!$n_Lpresto_Fetcher$CombinedRequestBuilder$)) {
    $n_Lpresto_Fetcher$CombinedRequestBuilder$ = new $c_Lpresto_Fetcher$CombinedRequestBuilder$();
  }
  return $n_Lpresto_Fetcher$CombinedRequestBuilder$;
}
export { $m_Lpresto_Fetcher$CombinedRequestBuilder$ as $m_Lpresto_Fetcher$CombinedRequestBuilder$ };
//# sourceMappingURL=presto.-Fetcher$-Combined-Request-Builder$.js.map
